<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-lg-6 mx-auto">
        <div class="connexion-header d-flex justify-content-center align-items-center mb-4 mt-4">
          <div class="col-10 connexion-header-title">Connexion</div>
          <router-link :to="{ name: 'public-homepage'}" class="col-2 connexion-header-logo">
            <img src="@/assets/img/logo.png" alt=""/>
          </router-link>
        </div>
        <Form :validation-schema="schema" @submit="handleLogin">
          <div class="form-group">
            <Field class="form-control" name="email" placeholder="Email" type="text"/>
            <ErrorMessage class="error-feedback" name="email"/>
          </div>
          <div class="form-group">
            <div class="passwordWrapper">
              <Field :type="showPassword ? 'text' : 'password'" class="form-control" name="password" placeholder="Mot de passe" autocomplete="current-password"></Field>
              <img :src="showPassword ? require('@/assets/img/eye-view.png') : require('@/assets/img/eye-hide.png')" class="eyePassword" @click="showPassword = !showPassword" alt="" />
            </div>
            <ErrorMessage class="error-feedback" name="password"/>
          </div>

          <div class="form-group">
            <div v-if="message" class="alert alert-success" role="alert">
              {{ message }}
            </div>
            <div v-if="isEmailNotVerified" class="alert alert-info">
              Votre inscription n'est pas encore validée.<br/>
              Veuillez consulter vos emails.<br/>
              Pour reçevoir un nouvel email de vérification, cliquez <a href="#" @click="resendVerificationEmail">ici</a>
            </div>
            <div v-else-if="errorMessage" class="alert alert-danger" role="alert">
              {{ errorMessage }}
            </div>
          </div>

          <div class="form-group">
            <button :disabled="loading" class="btn btn-primary btn-block">
                        <span
                            v-show="loading"
                            class="spinner-border spinner-border-sm"
                        ></span>
              <span>Se connecter</span>
            </button>

            <div class="login-group-help" >
              <router-link :to="{ name: 'public-forget-password'}" >
                Mot de passe oublié ?
              </router-link>
              <br><br>
              <router-link :to="{ name: 'public-register-approach'}" >
                Créer un compte
              </router-link>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import AuthApi from "@/api/AuthApi";
import RouteEnum from "@/router/RouteEnum";

export default {
  name: "login",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      email: yup.string().required("L'e-mail est requis"),
      password: yup.string().required("Le mot de passe est requis"),
    });

    return {
      loading: false,
      showPassword: false,
      message: "",
      errorMessage: "",
      isEmailNotVerified: false,
      resendLoading: false,
      currentEmail: "",
      schema,
    };
  },
  mounted() {
    const token = this.$route.query.token;
    const roles = this.$route.query.roles;
    const id = this.$route.query.id;
    const isDesactivated = this.$route.query.isDesactivated;

    if (token) {
      this.loginWithToken({token, roles, id, isDesactivated});
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  methods: {
    handleLogin(user) {
      this.loading = true;
      this.message = "";
      this.errorMessage = "";
      this.isEmailNotVerified = false;
      this.currentEmail = user.email.trim();

      this.$store.dispatch("auth/login", user).then(
          () => {
            this.message = 'Chargement en cours ...'
            localStorage.setItem('emailOnLogin', user.email.trim());
            setTimeout(function (router) {
              router.push({name: RouteEnum.DASHBOARD});
            }, 5000, this.$router);
          },
          (error) => {
            this.loading = false;
            this.errorMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();


            if (this.errorMessage && (this.errorMessage.includes('vérifier votre adresse email') || this.errorMessage.includes('email non vérifié'))) {
              this.isEmailNotVerified = true;
            }

          }
      );

    },

    resendVerificationEmail() {
      if (!this.currentEmail) {
        return;
      }

      this.resendLoading = true;

      AuthApi.resendVerificationEmail(this.currentEmail)
          .then(() => {
            this.resendLoading = false;
            this.message = "Email de vérification renvoyé avec succès ! Veuillez consulter votre boîte mail.";
            this.errorMessage = "";
            this.isEmailNotVerified = false;
          })
          .catch((error) => {
            this.resendLoading = false;
            const errorMsg = (error.response && error.response.data && error.response.data.message)
                || "Une erreur est survenue lors de l'envoi de l'email.";
            alert(errorMsg);
          });
    },

    loginWithToken(user) {
      const token = user.token;
      const roles = user.roles.split(",");
      const id = user.id;
      const isDesactivated = false;

      const data = {
        "roles": roles,
        "id": id,
        "isDesactived": isDesactivated
      }

      const response = {
        "token": token,
        "data": data
      }

      this.loading = true;
      this.message = "";
      try {
        localStorage.setItem('user', JSON.stringify(response));

        this.message = 'Connexion réussie';
        setTimeout(function (router) {
          localStorage.removeItem('emailOnLogin');
          router.push({name: RouteEnum.DASHBOARD});
        }, 5000, this.$router);
      } catch (error) {
        this.loading = false;
        this.errorMessage =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString();
      }
    },
    password: function () {
      this.$router.push({name: 'public-forget-password'});
    }
  },
};
</script>
